<template>
  <div
    class="mall-pack-mark"
    :class="`mall-pack-mark--${size}`"
    :aria-label="ariaLabel"
  >
    <span class="mall-pack-mark__bundle" aria-hidden="true">
      <span class="mall-pack-mark__row">
        <i /><i /><i />
      </span>
      <span class="mall-pack-mark__row">
        <i /><i /><i />
      </span>
    </span>
    <span class="mall-pack-mark__copy">
      <strong>{{ packLabel }}</strong>
      <em>낱개 주문 불가</em>
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { formatOrderPackLabel, normalizeOrderStep } from '@/utils/mallSell'

const props = withDefaults(
  defineProps<{
    orderStep: number
    sellUnit?: unknown
    size?: 'card' | 'detail' | 'inline'
  }>(),
  {
    size: 'inline',
  },
)

const packBase = computed(() => formatOrderPackLabel(normalizeOrderStep(props.orderStep), props.sellUnit))
const packLabel = computed(() =>
  props.size === 'detail' ? `${packBase.value}으로 주문할 수 있습니다` : packBase.value,
)
const ariaLabel = computed(() => `${packBase.value} · 낱개 주문 불가`)
</script>

<style lang="scss" src="./MallOrderPackMark.scss"></style>
